export default "__VITE_ASSET__$Z3h7KZP__"